import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/auth.service';
import type { TipoUsuario } from '../types';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedTypes?: TipoUsuario[];
  requireAuth?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  allowedTypes,
  requireAuth = true,
}) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const [userType, setUserType] = useState<TipoUsuario | null>(null);
  const [dashboardRoute, setDashboardRoute] = useState('/login');

  useEffect(() => {
    const checkAuth = async () => {
      console.log('AUTH_ProtectedRoute: Iniciando verificação de autenticação');
      console.log('AUTH_ProtectedRoute: URL atual:', window.location.pathname);

      const token = await authService.getToken();
      console.log('AUTH_ProtectedRoute: Token disponível:', !!token);
      if (token && typeof token === 'string') {
        console.log('AUTH_ProtectedRoute: Token (primeiros 20 chars):', token.substring(0, 20) + '...');
      }

      const currentUser = await authService.getCurrentUser();
      console.log('AUTH_ProtectedRoute: Usuário atual:', currentUser);

      try {
        const auth = await authService.isAuthenticated();
        console.log('AUTH_ProtectedRoute: Resultado isAuthenticated:', auth);
        setIsAuthenticated(auth);
        const type = await authService.getUserType();
        if (type) {
          setUserType(type as TipoUsuario);
        }
        const route = await authService.getDashboardRoute();
        setDashboardRoute(route);
        setLoading(false);
      } catch (error) {
        console.error('AUTH_ProtectedRoute: Erro na verificação:', error);
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    console.log('AUTH_ProtectedRoute: Renderizando loading...');
    return <div>Carregando...</div>;
  }

  if (!requireAuth) {
    console.log('AUTH_ProtectedRoute: Autenticação não requerida, renderizando children');
    return <>{children}</>;
  }

  if (!isAuthenticated) {
    console.log('AUTH_ProtectedRoute: Não autenticado, redirecionando para /login');
    return <Navigate to="/login" replace />;
  }

  console.log('AUTH_ProtectedRoute: Autenticado com sucesso!');

  if (!allowedTypes || allowedTypes.length === 0) {
    return <>{children}</>;
  }

  if (userType && allowedTypes.includes(userType)) {
    return <>{children}</>;
  }

  return <Navigate to={dashboardRoute} replace />;
};

export default ProtectedRoute;
